import { memo } from "react";

import { useSelector } from "react-redux";

import { SWReactCountryIcons, SWReactIcons } from "@similarweb/icons";
import type { IconName } from "@similarweb/icons";

import { countryTextByIdFilter } from "app/filters/ngFilters";
import { GAConnectedPropertyInfo } from "app/pages/activation";
import { useWebSources } from "app/pages/benchmark-tracker/hooks/topFilters/useWebSources";
import { useFormattedDuration } from "app/pages/benchmark-tracker/hooks/useFormattedDuration";
import { selectSelectedBenchmark } from "app/pages/benchmark-tracker/store/selectors/entitySelectors";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { useUserdataActivationQuery } from "../../../queries/useUserdataActivationQuery";

import {
    StyledBenchmarkName,
    StyledIconWrapper,
    StyledInfoItem,
    StyledInfoWrapper,
    StyledPdfHeader,
    StyledText,
} from "./styles";

export const PdfHeader = memo(() => {
    const selectedBenchmark = useSelector(selectSelectedBenchmark);
    const { name, activationSetId } = selectedBenchmark ?? {};
    const { country, duration, webSource, granularity } = proNavigator.getParams();
    const { availableWebSources } = useWebSources();
    const formattedDuration = useFormattedDuration(granularity, duration);

    const webSourceInfo = availableWebSources.find((source) => source.id === webSource);

    const { data: currentActivationSet } = useUserdataActivationQuery(activationSetId);

    return (
        <StyledPdfHeader>
            <div>
                <StyledBenchmarkName>{name}</StyledBenchmarkName>
                <StyledInfoWrapper>
                    <StyledInfoItem>
                        <StyledIconWrapper>
                            <SWReactIcons iconName="daily-ranking" />
                        </StyledIconWrapper>
                        <StyledText>{formattedDuration}</StyledText>
                    </StyledInfoItem>

                    <StyledInfoItem>
                        <StyledIconWrapper>
                            <SWReactCountryIcons countryCode={country} />
                        </StyledIconWrapper>
                        <StyledText>{countryTextByIdFilter()(country)}</StyledText>
                    </StyledInfoItem>

                    {webSourceInfo ? (
                        <StyledInfoItem>
                            <StyledIconWrapper>
                                <SWReactIcons iconName={webSourceInfo.icon as IconName} />
                            </StyledIconWrapper>
                            <StyledText>{webSourceInfo.text}</StyledText>
                        </StyledInfoItem>
                    ) : null}
                </StyledInfoWrapper>
            </div>

            {activationSetId && currentActivationSet?.trafficSource === "GA" ? (
                <GAConnectedPropertyInfo activationId={activationSetId} />
            ) : null}
        </StyledPdfHeader>
    );
});

PdfHeader.displayName = "PdfHeader";
